module.exports = {
    window : window,
    document : document    
}


//////////////////
// WEBPACK FOOTER
// ./src/browser.js
// module id = 2
// module chunks = 0 1 2